import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/sidebar_logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-bc3f8cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar navbar-expand navbar-light d-none d-md-flex px-6 ps-0",
  id: "topbar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "me-auto ms-4"
}
const _hoisted_5 = { class: "breadcrumb fw-bold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "breadcrumb-item active d-flex align-items-center",
  "aria-current": "page"
}
const _hoisted_9 = {
  key: 0,
  class: "navbar-user"
}
const _hoisted_10 = { class: "navbar-nav" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Home")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Agenda")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Chat")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Financeiro")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Mais")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-4 pe-3 text-paragraph text-muted" }, "|", -1))
const _hoisted_17 = { class: "text-subtitle me-3" }
const _hoisted_18 = {
  href: "#",
  class: "avatar avatar-sm dropdown-toggle"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "fa-solid fa-user-circle display-3 text-muted"
}
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-end cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.$paths.home
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ol", _hoisted_5, [
          (_ctx.link)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                custom: "",
                to: _ctx.link
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(_ctx.linkName), 1)
                  ], 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.sublink)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                custom: "",
                to: _ctx.sublink
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(_ctx.sublinkName), 1)
                  ], 8, _hoisted_7)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.current), 1)
        ])
      ]),
      (_ctx.session)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              (_ctx.session.approved && _ctx.session.is_subscriber)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_router_link, {
                      "active-class": "router-link-active",
                      to: _ctx.$paths.home
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      "active-class": "router-link-active",
                      to: _ctx.$paths.appointments.list
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      "active-class": "router-link-active",
                      to: _ctx.$paths.chat.list
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      class: _normalizeClass({ 'router-link-active': _ctx.financialLinkActive }),
                      to: `${_ctx.$paths.financial.list}/repasses`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["class", "to"])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: `${_ctx.$paths.more}/gerenciar-perfil`,
                class: _normalizeClass({ 'router-link-active': _ctx.moreLinkActive })
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _hoisted_16,
            _createElementVNode("div", {
              class: "dropdown cursor-pointer align-items-center d-flex",
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.avatarOver && _ctx.avatarOver(...args))),
              onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.avatarLeave && _ctx.avatarLeave(...args)))
            }, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.session?.nickname), 1),
              _createElementVNode("a", _hoisted_18, [
                (_ctx.session?.profile_image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.session?.profile_image,
                      alt: "",
                      width: "40",
                      height: "40",
                      class: "rounded-circle"
                    }, null, 8, _hoisted_19))
                  : (_openBlock(), _createElementBlock("i", _hoisted_20))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "dropdown-item text-danger"
                }, "Sair")
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}